/*
 * @Description: 待开
 * @Date: 2020-10-14 15:58:13
 */
import { invoice } from '@/api/ajax';
import fields from './fields';
import search from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';
import createExtend from '@C/createExtend';
import { PAY_BANK_TYPE_KEY, PAY_TYPE_KEY } from '@/common/constants/bank';
import {
  payTypeRowLabelFiled,
  payTypeSearchFiled,
  bankRowLabelFiled
} from '@/common/fields/bank';
import openBill from '../../openBill.vue';
// 申请委托 发票
import invoiceOpenListToBeOpened from '@/page/bill/child/invoiceTable/ApplyForCommission';

const openBillEvent = async ({ table, invoiceOrderType }) => {
  const { pdata } = await invoice.detail();
  if (pdata.csoReceiptAddressList && pdata.csoReceiptAddressList.length > 0) {
    //如果填写过地址
    const initSupData = table.tableResp.supplierData || {
      supplierId: '',
      supplierName: ''
    };
    createExtend(openBill, {
      initSupData,
      invoiceOrderType
    }).$on('confirm', () => {
      table.saveSuccess();
    });
  } else {
    table
      .$confirm('请您先完善邮寄信息', '提示', {
        confirmButtonText: '前去完善',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        table.$router.push({
          path: '/account/index'
        });
      });
  }
};

// const defineReactive = Vue.util.defineReactive;
// TableRenderClass()
let example = new TableRenderClass({
  fields,
  search
});

let tobeOpendPart = example.createPart({
  name: '待开票',
  search: [
    'paymentObject',
    'orderNo',
    'daikaipiaodingdanType',
    PAY_BANK_TYPE_KEY,
    payTypeSearchFiled
  ],
  list: invoice.invoiceOpenList,
  requestNow: true,
  fields: [
    'index',
    'projectName',
    'professionType',
    'orderNo',
    'invoiceOrderType',
    'receiveDt',
    'paymentObject',
    'applicationStatus',
    {
      ...bankRowLabelFiled[PAY_BANK_TYPE_KEY], // bug:#30124:切换tab导致宽度未刷新，在这宽度不写死
      width: 'none'
    },
    {
      ...payTypeRowLabelFiled[PAY_TYPE_KEY], // bug:#30124:切换tab导致宽度未刷新，在这宽度不写死
      width: 'none'
    },
    'dakuanjine'
  ],
  moreBtnArr: [
    {
      name: '申请开票',
      icon: '',
      type: 'primary',
      async fn(app, table) {
        openBillEvent({ app, table, invoiceOrderType: 1 });
      }
    },
    {
      name: '申请委托代开发票',
      async fn() {
        createExtend(invoiceOpenListToBeOpened);
        // apply.$on('close', () => {

        // });
      }
    },
    {
      name: '申请服务费发票',
      async fn(app, table) {
        openBillEvent({ app, table, invoiceOrderType: 4 });
      }
    }
  ]
});

export default tobeOpendPart;
